import { NavLink } from "react-router-dom";

import "./Footer.css";

// Images


const Footer = () => {

    return (<footer className="footer-main">

        <div className="footer-sub" >

            {/* Above part */}

            <div className="footer-1">

                <div className="f1-sub" style={{ marginTop: "-10px" }} >
                    <h2 style={{ fontFamily: '"DM Serif Display", sans-serif', letterSpacing: "2px", fontSize: "31px" }} >ANUBHAVA <br/> MONTESSORI<span style={{ color: "#ff8943" }}>.</span></h2>
                    <p className="footer-discription" >
                        Our school is a place where we respect each child’s personality, where their potential is nurtured and their unique and natural sense of wonder is encouraged and celebrated. <br />
                    </p>
                </div>

                <div className="f1-sub" >
                    <h2>Programs</h2>
                    <p className="f1-list">
                        <NavLink className={"f1-spans"} to="/programs/toddler-program" >Toddler Program</NavLink>
                        <NavLink className={"f1-spans"} to="/programs/primary-program" >Primary Program</NavLink>
                        <NavLink className={"f1-spans"} to="/programs/elementary-program" >Elementary Program</NavLink>
                    </p>
                </div>
                <div className="f1-sub" >
                    <h2>Pages</h2>
                    <p className="f1-list">
                        <NavLink className={"f1-spans"} to="/" >Home</NavLink>
                        <NavLink className={"f1-spans"} to="/about-us" >About us</NavLink>
                        <NavLink className={"f1-spans"} to="/montessori" >Montessori</NavLink>

                        <span className={"f1-spans"} style={{ cursor: "default" }}>Gallery</span>
                        <NavLink className={"f1-spans"} to="/contact" >Contact us</NavLink>
                    </p>
                </div>
                <div className="f1-sub" >
                    <h2>Socials</h2>
                    <p className="f1-list">
                        <a className="socials-links" href="https://www.instagram.com/amhoc_montessori/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram glass-box"></i><span>@amhoc_montessori</span></a>
                        <a className="socials-links" href="https://www.youtube.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-youtube glass-box" /><span>Anubhava Montessori</span></a>
                        <a className="socials-links" href="https://www.facebook.com/" target="_blank" rel="noreferrer"><i className="fa-brands fa-facebook-f glass-box"></i><span>Anubhava Montessori</span></a>
                    </p>
                </div>

            </div>

            <hr style={{ width: "100%", margin: "50px auto", marginBottom: "20px", height: "0.1px", background: "#fff", border: "none" }} />

            {/* Below part */}
            <div className="footer-2">

                <div className="f2-sub" style={{ textAlign: "left" }}>
                    <NavLink className={"f2-links"} to="/privacy-policy"><span style={{ fontWeight: "300" }}>Privacy Policy</span></NavLink>
                    <NavLink className={"f2-links"} to="/terms-of-use"><span style={{ fontWeight: "300" }}>Terms of Use</span></NavLink>
                </div>

                <div className="f2-sub" >
                    <p style={{ color: "#ff8943" }}><span style={{ fontWeight: "300", color: "#fff" }}>Developed by </span>Digify Media</p>
                </div>

                <div className="f2-sub" style={{ textAlign: "right" }}>
                    <p>Anubhava Montessori | <span style={{ fontWeight: "300" }}>All Rights Reserved</span></p>
                </div>

            </div>

        </div>

    </footer>)

}

export default Footer;